import { setAgentInfo } from "./agentSlice";
import { getAgentInfo } from "../../../api/post/agentInfoApi";

/**
 * Thunk to fetch agent details from the API
 */
export const fetchAgentInfo = () => async (dispatch) => {
  try {
    const response = await getAgentInfo();
    dispatch(setAgentInfo(response.data)); // Store agent info in Redux state
  } catch (error) {
    console.error("Failed to fetch agent info:", error);
  }
};